import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import { WeatherTimeComponent } from '../weather-time/weather-time.component';
import { MessageComponent } from '../message/message.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-resume-panel',
  standalone: true,
  imports: [NgFor, NgIf, WeatherTimeComponent, NgClass, MessageComponent, HttpClientModule],
  templateUrl: './resume-panel.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ResumePanelComponent implements OnInit, OnDestroy {

  public panel: any;
  public showDistance: boolean = false;

  public slug: any;
  private _intervalDistanceId: any;
  private _intervalPanelId: any;

  private _subscription: Subscription = new Subscription();

  constructor(private route: ActivatedRoute,
              private _http: HttpClient,
              private _cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this._intervalDistanceId = setInterval(() => {
      this._toggleDisplay();
    }, 8000);

    this._intervalPanelId = setInterval(() => {
      this._getPanel();
    }, 1000 * 60 * 15);

    this._getSlugParam();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();

    if (this._intervalDistanceId) {
      clearInterval(this._intervalDistanceId);
    }    
    
    if (this._intervalPanelId) {
      clearInterval(this._intervalPanelId);
    }
  }

  public getLocationCoords(origin: string) {
    const [latStr, lngStr] = origin.split(',').map(coord => coord.trim());
    const lat = parseFloat(latStr);
    const lng = parseFloat(lngStr);
    return { lat: lat, lng: lng };
  }

  public getMinutes(seconds: number) {
    const minutes: number = seconds / 60;
    return Math.round(minutes * 10) / 10;
  }

  public getKilometers(meters: number): number {
    const km: number = meters / 1000;
    return parseFloat(km.toFixed(1));
  }

  public getIcon(mode: string): string {
    let iconClass: string = '';

    switch (mode) {
      case 'driving':
        iconClass = 'bi-cart-front'
        break;
    
      default:
        iconClass = 'bi-cart-front'
        break;
    }

    return iconClass;
  }

  private _toggleDisplay() {
    this.showDistance = !this.showDistance;
    this._cdr.detectChanges();
  }

  private async _getSlugParam() {
    this.slug = this.route.snapshot.paramMap.get('id');

    if (this.slug) {
      await this._getPanel();
    } else {
      this.slug = null;
    }
  }

  private async _getPanel(): Promise<any> {
    // ID STADIUM = d4bc647d-60d5-4765-9ada-e8b5ec8a623d
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjkyYzdiZTc5LWRjNTktNGYyZS04MjU4LTY5YTkzM2M5ZWVlMCIsImlhdCI6MTcxODIyODcwNH0.K6il3INv-JuFxrp5r1vKmfqt-wMHDr6dPVQG0BuBias';
    const url = `https://smartpanel.cochabamba.bo/api/v1/panels/${this.slug}`;
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' });
    
    this._http.get<any>(url, { headers }).subscribe((panel: any) => {
      if (panel.active) {
        this.panel = panel;
      }
    });
  }
}
